module.exports = __webpack_public_path__ + "img/profitran.42cf8797.png";